export default __webpack_public_path__ + "static/media/icon-twitter.5c1b3213.svg";